import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// ---Third-party imports
import React from 'react';
import { Icon, Label, Menu, Image, Header } from 'semantic-ui-react';
import clsx from 'clsx';
// ---Framework imports
import { Actions, Sel } from 'uix/registries';
import { useGraphics, useSelector, useState, useMemo, useActions } from 'uix/hooks';
import { callIfFunc, size } from 'ldash';
import log from 'uix/logging';
import { AutoPortal } from 'uix/components';
import { Graphics } from 'uix/graphics';
// ---Local imports
import S from './titleGrid.scss';
import { wcUrl, ViewerLink } from './utils';
// ---Globals
let SAMPLE_DATA = [
    {
        title: 'Und Ihr?',
        author: 'Erler, Fritz',
        origin: 'Stuttgart: Eckstein & Stähle, [1917]',
        pageId: 440859,
        pageWidth: 304,
        pageHeight: 419,
        desc: 'test',
        subtitle: 'test',
        released: false
    }
];
export const TypeIcon = ({ datatype, subtype })=>{
    let k = `${datatype}_${subtype}`;
    return /*#__PURE__*/ _jsx(Image, {
        className: S.typeIcon,
        inline: true,
        width: "14px",
        src: Graphics.types && Graphics.types[k]
    }, k);
};
export const StatusLabel = ({ i18n, item })=>{
    return item.ot_state !== undefined ? /*#__PURE__*/ _jsxs(Label, {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: S.label,
                children: i18n.get(`ot_state_${item.ot_state}`)
            }),
            /*#__PURE__*/ _jsx(Icon, {
                name: "circle",
                size: "small",
                color: item.ot_state > 0 ? 'green' : 'orange',
                className: S.typeIcon
            })
        ]
    }) : null;
};
export const TitleGrid = ({ data = SAMPLE_DATA, grid = true, renderFooter = null, linkProps = {}, align = 'center' })=>{
    //XXX: probably kill this transformation
    data = useMemo(()=>{
        if (size(data) > 0 && data[0].mods) {
            return data.map((row)=>({
                    ...row,
                    title: row.mods.title,
                    author: row.mods.author,
                    lithographer: row.mods.lithographer,
                    subtitle: row.mods.subtitle,
                    origin: row.mods.origin,
                    pageId: row.op_ot_id,
                    pageWidth: row.imgwidth,
                    pageHeight: row.imgheight
                }));
        }
        return data;
    });
    let go = useActions(Actions.go);
    const apiurl = useSelector(Sel.apiurl);
    const i18n = useSelector(Sel.i18n);
    let [listView, setSwapView] = useState(true);
    if (grid) {
        listView = false;
    }
    let changeDirection = ()=>setSwapView(!listView);
    let items = data.map((item, i)=>{
        let { otid, title, author, lithographer, origin, subtitle, pageId, pageWidth, pageHeight, crop, released } = item;
        let maxPageHeight = 150;
        let maxPageWidth = 150;
        if (pageHeight > maxPageHeight) {
            pageWidth = Math.round(pageWidth * maxPageHeight / pageHeight);
            pageHeight = maxPageHeight;
        }
        if (pageWidth > pageHeight) {
            pageHeight = Math.round(pageHeight * maxPageWidth / pageWidth);
            pageWidth = maxPageWidth;
        }
        const pageImg = {
            width: pageWidth,
            height: pageHeight,
            backgroundPosition: 'center',
            minWidth: pageWidth,
            minHeight: pageHeight,
            transform: listView ? 'scale(0.75)' : 'scale(1)'
        };
        linkProps = {
            ...linkProps,
            id: otid
        };
        let creator = !author ? lithographer : author;
        const footer = callIfFunc(renderFooter, item);
        // if no pageId available show placeholder
        let imageSrc = pageId ? wcUrl(apiurl, 304, pageId) : apiurl.href('/static/graphics/error/noImageSuppliedThumbTransparent.svg');
        return /*#__PURE__*/ _jsxs("div", {
            className: S.card,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: S.titleInfo,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: S.showcase,
                            children: /*#__PURE__*/ _jsxs(ViewerLink, {
                                ...linkProps,
                                children: [
                                    !listView && /*#__PURE__*/ _jsxs("div", {
                                        className: S.infoArea,
                                        children: [
                                            ' ',
                                            /*#__PURE__*/ _jsx(StatusLabel, {
                                                i18n: i18n,
                                                item: item
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("img", {
                                        style: pageImg,
                                        loading: "lazy",
                                        src: imageSrc
                                    })
                                ]
                            })
                        }, i),
                        /*#__PURE__*/ _jsxs("div", {
                            className: S.content,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: S.topContainer,
                                    children: [
                                        creator ? /*#__PURE__*/ _jsx("a", {
                                            className: S.creator,
                                            children: creator
                                        }) : /*#__PURE__*/ _jsx("h2", {
                                            className: S.title,
                                            children: /*#__PURE__*/ _jsx(ViewerLink, {
                                                ...linkProps,
                                                children: title
                                            })
                                        }),
                                        listView && /*#__PURE__*/ _jsxs("div", {
                                            className: clsx(S.infoArea, S.list),
                                            children: [
                                                ' ',
                                                /*#__PURE__*/ _jsx(StatusLabel, {
                                                    i18n: i18n,
                                                    item: item
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: S.textArea,
                                    children: /*#__PURE__*/ _jsxs(ViewerLink, {
                                        ...linkProps,
                                        children: [
                                            creator && /*#__PURE__*/ _jsx("h2", {
                                                className: S.title,
                                                children: title
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: S.subtitle,
                                                children: subtitle
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: S.bottomContainer,
                                    children: [
                                        /*#__PURE__*/ _jsx("a", {
                                            className: S.origin,
                                            children: origin
                                        }),
                                        listView ? /*#__PURE__*/ _jsx(TypeIcon, {
                                            datatype: item.datatype,
                                            subtype: item.subtype
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                footer && /*#__PURE__*/ _jsx("a", {
                    className: S.footer,
                    children: footer
                })
            ]
        }, i);
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            grid === undefined && /*#__PURE__*/ _jsx(AutoPortal, {
                target: "TabMenuPortal",
                children: /*#__PURE__*/ _jsx(Menu, {
                    children: /*#__PURE__*/ _jsx(Menu.Item, {
                        icon: listView === true ? 'grid layout' : 'th list',
                        title: "Grid Layout",
                        onClick: changeDirection
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: clsx(S.flexContainer, listView && clsx(S.list, align === 'left' ? S.left : S.center)),
                children: items
            })
        ]
    });
};
